<template>
    <div v-if="hide || active || formSteps" v-show="active"
        :id="group + '_' + name"
        :class="[{active}, 'tab-bar-content', 'tab-bar-content-' + group]"
        :aria-labelledby="group + '_' + name + '_label'"
        role="tabpanel"
        tabindex="0">
        <slot v-if="hide || active || formSteps && !stepAsComponent"/>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator';
    import {TabBarLabel} from './TabBarLabel.vue';

    @Component({
        name: 'TabBarContent',
    })
    export default class TabBarContent extends TabBarLabel
    {
        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) hide: boolean;

        stepAsComponent = true;

        mounted()
        {
            this.stepAsComponent = this.formSteps?.stepAsComponent || false;
        }
    };
</script>